import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Client } from '@core/models/client.model';

export interface ClientState extends EntityState<Client> {
  selectedIds: string[];
}

export function createInitialState(): ClientState {
  return null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'client', resettable: true })
export class ClientStore extends EntityStore<ClientState> {
  constructor() {
    super(createInitialState());
  }
}
